import React from 'react';
import { Layout, Typography, Spin } from 'antd';
import { useSemanticDataMap } from '@/hooks/useSemanticDataMap';
import {
  ObjectList,
  ObjectInfo,
  MappingInfo,
} from '@/components/SemanticDataMapping';
import { useEmbedMode } from '@/hooks/useEmbedMode';

const { Sider, Content } = Layout;
const { Title } = Typography;

interface SemanticDataMappingProps {
  ontologyId: number;
}

const SemanticDataMapping: React.FC<SemanticDataMappingProps> = ({
  ontologyId,
}) => {
  const { isEmbedMode } = useEmbedMode();
  const {
    filteredObjects,
    selectedObject,
    selectedObjectId,
    objectInfo,
    mappingInfo,
    semanticMappingLoading,
    isLoading,
    error,
    searchText,
    handleSearch,
    handleSelectObject,
    handleRefreshData,
  } = useSemanticDataMap(ontologyId);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return <></>;
  }

  return (
    <div className="flex overflow-hidden">
      <Sider
        width="20%"
        className={`${isEmbedMode ? 'h-[calc(100vh-40px)]' : 'h-[calc(100vh-64px)]'} bg-white border-r border-gray-200 flex flex-col overflow-hidden`}
      >
        <ObjectList
          filteredObjects={filteredObjects}
          selectedObjectId={selectedObjectId}
          searchText={searchText}
          handleSearch={handleSearch}
          handleSelectObject={handleSelectObject}
        />
      </Sider>

      <Content className="p-6 bg-gray-50 h-full box-border">
        <div className="flex justify-between items-center mb-6">
          <Title level={4} className="text-gray-800 font-medium m-0">
            语义与数据映射查看
          </Title>
        </div>

        <ObjectInfo
          selectedObject={selectedObject}
          objectInfo={objectInfo}
          isLoading={semanticMappingLoading}
        />

        <MappingInfo
          selectedObjectId={selectedObjectId}
          mappingInfo={mappingInfo}
          ontologyId={ontologyId}
          selectedObject={selectedObject}
          isLoading={semanticMappingLoading}
        />
      </Content>
    </div>
  );
};

export default SemanticDataMapping;
